import module from '../module';
import Constants from '../../../utils/CommonConstants';

export class ProfileController {
    static $inject = [ '$scope', '$rootScope', 'AuthenticationService', 'Message', 'UserProfile', 'Session' ];

    constructor(scope, rootScope, authenticationService, messageService, userProfileService, sessionService) {
        this._scope = scope;
        this._messageService = messageService;
        this._userProfileService = userProfileService;
        this._sessionService = sessionService;
        this._rootScope = rootScope;
    }
}

module.controller('Cartonomy.Profile.ProfileController', ProfileController);



// WEBPACK FOOTER //
// ./src/modules/profile/controllers/ProfileController.js